<template>
  <header class="data__header">
    <h1 class="data__title">
      <a
        :href="permalink"
        class="waldoLink"
        target="_blank"
        title="View chart in a new tab."
      >
        {{ title }}
        <sup class="appendedIcon supIcon"
          >&zwj;<i class="far fa-external-link-alt"></i>&zwj;</sup
        >
      </a>
    </h1>
    <p class="data__subtitle" v-if="subtitle" v-html="subtitle"></p>
  </header>
  <Tabs
    :tabs="state.tabs"
    v-on:tab-changed="tabChanged"
    :controls="'figureContainer-' + slug"
  ></Tabs>
  <section class="data__figures" :id="'figureContainer-' + slug">
    <section
      class="data__figureContainer"
      v-show="state.activeTableIndex === 0"
    >
      <div class="data__selectDatasetButtons inlineList">
        <button
          v-for="(buttonTitle, index) in buttonTitles"
          class="chart-switcher buttonLink"
          :class="{ activeView: index === 0 }"
          :value="index"
          v-html="buttonTitle"
        ></button>
      </div>
      <slot name="loading">
        <div class="figurePlaceholder chartPlaceholder">
          <div class="figurePlaceholder__content">
            <span class="figurePlaceholder__loading">Loading</span>
          </div>
        </div>
      </slot>
      <Chart :src-url="jsonUrl" :slug="slug" ref="chart" :margin="chartMargin">
      </Chart>
      <div class="chart-interaction" v-if="showLegend">
        <div class="chart-legend" :id="legendId + '-legend'"></div>
      </div>
      <!-- //.chart-interaction -->
    </section>
    <section
      class="data__figureContainer"
      v-show="state.activeTableIndex === 1"
    >
      <TabTable
        :tables-data="data"
        :theme="buttonTitles.length > 1 ? 'buttons' : ''"
      ></TabTable>
    </section>
  </section>
  <div class="data__controls chartControls" data-html2canvas-ignore>
    <div class="inlineList chartControls__buttons">
      <h2 class="chartControls__title">Downloads:</h2>
      <a
        v-for="download in downloads"
        :href="download.file"
        class="button button--primary button--small"
        ><span class="prependedIcon"><i class="fas fa-download"></i>&zwj;</span
        >{{ download.linkText }}</a
      >
      <button
        class="button button--primary button--small"
        v-on:click="takeSnapshot"
      >
        <span class="prependedIcon"><i class="fas fa-download"></i>&zwj;</span
        >Screenshot (.png)
      </button>
    </div>
  </div>
</template>

<script setup>
import {
  computed,
  markRaw,
  onMounted,
  nextTick,
  reactive,
  ref,
  watch,
} from "vue";
import Chart from "./Chart.vue";
import Tabs from "./Tabs.vue";
import TabTable from "./TabTable.vue";

//template refs
const chart = ref(null);

//props
const props = defineProps({
  permalink: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
  },
  slug: {
    type: String,
    required: true,
  },
  jsonUrl: {
    type: String,
    required: true,
  },
  data: {
    type: [Object, String],
  },
  buttonTitles: {
    type: Array,
    default: () => [],
  },
  chartMargin: {
    type: Object,
    default: () => ({}),
  },
  showLegend: {
    type: Boolean,
    default: true,
  },
  legendId: {
    type: String,
    required: true,
  },
  downloads: {
    type: Array,
    default: () => [],
  },
});

//data
const state = reactive({
  tabs: [
    {
      index: 0,
      title: "View Chart",
    },
    {
      index: 1,
      title: "View Table",
    },
  ],
  activeTableIndex: 0,
});
const overlayClustered = ref(null);

//lifecycle
onMounted(() => {});

//methods
const tabChanged = function (index) {
  state.activeTableIndex = index;
};
const takeSnapshot = function () {
  chart.value.snapshot();
};

//computed
</script>

<style scoped lang="scss"></style>
